import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { map, switchMap, take } from 'rxjs/operators';

import * as fromActions from '../actions/header.actions';
import * as fromSelectors from '../selectors/header.selectors';
import { HeaderState, Backbutton } from '../../models/rootState.model';

@Injectable()
export class HeaderEffects {

    constructor(
        private actions$: Actions,
        private store: Store<HeaderState>,
        private router: Router,
        private location: Location
    ) { }

    @Effect({ dispatch: false })
    backbuttonClicked$ = this.actions$.pipe(
        ofType(fromActions.HEADER_ACTIONS_TYPES.BACK_BUTTON_CLICKED),
        switchMap(() => this.store.select(fromSelectors.selectHeaderBackbutton).pipe(take(1))),
        map((buttonAction: Backbutton) => {

            if (buttonAction == 'manual') { return; }

            if (typeof (buttonAction) == 'string') {
                this.router.navigate([buttonAction]);
            } else if (typeof (buttonAction) == 'boolean') {
                if (buttonAction == true) {
                    this.location.back();
                }
            } else if (typeof (buttonAction) == 'function') {
                buttonAction();
            }
            this.store.dispatch(new fromActions.Action_Header_StartLoader());
        })
    );

}
